import Button from "@material-ui/core/Button"
import Dialog from "@material-ui/core/Dialog"
import DialogActions from "@material-ui/core/DialogActions"
import DialogTitle from "@material-ui/core/DialogTitle"
import DialogContent from "@material-ui/core/DialogContent"
import Typography from "@material-ui/core/Typography"
import TextField from "@material-ui/core/TextField"
import { useZodSchemas } from "../../../hooks/use-zod-schemas"
import { UserViewModel } from "../../api/user"
import { useTheme } from "@material-ui/core"
import { useUserMutations } from "../../hooks/use-user-mutations"
import React from "react"
import { useTranslations } from "./use-translations"

const UpdateEmailDialog = ({ user }: { user: UserViewModel }) => {
  const theme = useTheme()
  const translations = useTranslations()
  const { updateUserEmail } = useUserMutations()
  const [anchor, setAnchor] = React.useState<HTMLButtonElement | null>(null)
  const [newEmail, setNewEmail] = React.useState("")
  const [error, setError] = React.useState<string | null>(null)
  const { ZodEmail } = useZodSchemas()

  const closeDialog = () => {
    setAnchor(null)
    setNewEmail("")
    setError(null)
  }

  const handleUpdateEmail = () => {
    const parsedEmail = ZodEmail.safeParse(newEmail)
    if (!parsedEmail.success) {
      setError(parsedEmail.error.errors[0].message)
      return
    }

    closeDialog()
    updateUserEmail(user.id, { newEmail: parsedEmail.data })
    setNewEmail("")
    setError(null)
  }

  const handleSubmit = (event: React.FormEvent<HTMLFormElement>) => {
    event.preventDefault()
    return handleUpdateEmail()
  }

  return (
    <>
      <Button
        size="small"
        onClick={(e) => setAnchor(e.currentTarget)}
        variant="outlined"
        style={{ borderColor: theme.palette.divider }}
      >
        {translations.updateEmail}
      </Button>
      <Dialog
        open={Boolean(anchor)}
        onClose={closeDialog}
        fullWidth
        PaperProps={{ style: { padding: "8px 8px 24px 8px" } }}
      >
        <form onSubmit={handleSubmit}>
          <DialogTitle>{translations.updateEmail}</DialogTitle>
          <DialogContent>
            <Typography variant="body2" color="textSecondary" style={{ marginBottom: 32 }}>
              {translations.updateEmailDialogText}
            </Typography>
            <TextField
              onChange={(event) => setNewEmail(event.target.value)}
              value={newEmail}
              label={translations.email}
              error={Boolean(error)}
              helperText={error}
              autoFocus
              fullWidth
            />
          </DialogContent>
          <DialogActions style={{ marginLeft: 12, marginTop: 12, justifyContent: "flex-start" }}>
            <Button type={"submit"} variant="contained" color="primary" size="small">
              {translations.sendCode}
            </Button>
            <Button size="small" onClick={closeDialog}>
              {translations.cancel}
            </Button>
          </DialogActions>
        </form>
      </Dialog>
    </>
  )
}

export default UpdateEmailDialog
